'use client'
import type { AbstractIntlMessages } from 'next-intl'
import { NextIntlClientProvider } from 'next-intl'

interface IntlClientProviderProps {
  children: React.ReactNode
  locale: string
  messages: AbstractIntlMessages
}

// onError/getMessageFallback được định nghĩa ở đây (client) vì hàm không thể
// serialize khi truyền từ Server Component (AppProviders) vào NextIntlClientProvider.
export function IntlClientProvider({
  children,
  locale,
  messages,
}: IntlClientProviderProps) {
  return (
    <NextIntlClientProvider
      locale={locale}
      messages={messages}
      onError={(error) => {
        if (error.code === 'MISSING_MESSAGE') return
        console.error(error)
      }}
      getMessageFallback={({ key }) => key}
    >
      {children}
    </NextIntlClientProvider>
  )
}
